import { render } from "./postCard.vue?vue&type=template&id=32b1d4dc&scoped=true"
import script from "./postCard.vue?vue&type=script&lang=js"
export * from "./postCard.vue?vue&type=script&lang=js"

import "./postCard.vue?vue&type=style&index=0&id=32b1d4dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b1d4dc"]])

export default __exports__